import { NewsContentType } from '@/types/enum';

const image1 = 'https://pic0.xinmin.cn/xmwb/2022/11/18/191d3d8e-118b-4182-84e8-e4773b5a438f.jpg';
const image2 = 'https://pic0.xinmin.cn/xmwb/2022/11/18/cd5f7808-3724-40a9-89a5-1a1bb6e52377.jpg';
const image3 = 'https://pic0.xinmin.cn/xmwb/2022/11/18/09cf90cc-19ce-42c1-84ca-61abaf34666d.jpg';
export default {
  id: '20221118', //  模块 id
  title:
    '从源头管到餐桌，订单农业降低蔬菜农残风险', // 标题
  origin: '2022-11-18 09:34:18 来源：新民晚报', // 新闻来源
  editor: '编辑：金旻矣', // 编辑者
  content: [
    {
      type: 1,
      title: '',
      src: [image1],
    },
    
    {
      type: NewsContentType.Text,
      text:
        '图说：豇豆因喜温、喜旱，在鲜嫩的状态下极易招致虫害 采访对象提供（下同）',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '新民晚报讯（记者 张钰芸）正值豇豆的采摘季，在广东廉江市，几十位村民穿梭在一行行的豇豆架中，很快就摘满了一个个筐子。这些新鲜豇豆将被运往上海、北京等城市，成为市民餐桌上的美食。记者昨天从叮咚买菜获悉，叮咚买菜上线了一批通过新型订单种植种出的“三优”系列蔬菜，从十几种易引发高农药残留风险的蔬菜品种入手，在源头选择优质基地和优良种植方式，最大化地降低残留风险。其中，豇豆作为首批上线的品类之一，已经在不同产区的轮转中完善了订单种植方案，实现了长期稳定供应。 ',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '在常见的蔬菜品类中，豇豆因喜温、喜旱，在鲜嫩的状态下极易招致虫害。其中一种叫蓟马的小飞虫，从豇豆开花初期便会吸附在花苞里，繁殖速度极快，难以根除。另一种常见的是豇豆荚螟，会将卵产在花苞内，伴随豇豆生长的同时在其内部孵化，吸食内部汁液。 ',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        ' 在传统的种植方式中，解决豇豆虫害最直接的方式就是全程使用化学农药，不过这虽然可以帮助除虫、增加产量，但如果缺少科学的用药方案和最佳预防时间的指导，过度、过量使用也会增大农药残留的风险。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '但在叮咚买菜“三优”豇豆订单种植基地，对这一痼疾有了新的解决思路。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '据基地负责人李相斌介绍，基地以早预防、早治疗为原则，在豇豆生长早期就采用毒性更小的生物源农药和物理防控制剂，以减少成虫的密度以及虫卵附着，并使用安全、抗生素风险较小的生物有机菌肥来提供营养，既能帮助防病，也能达到增产效果。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        ' 经过多次的改进和磨合，李相斌的基地今年终于通过了叮咚买菜D-G.A.P的认证，这意味着基地在水质、土壤、人员和过程管理等各方面，具备了安全生产种植的基础。',
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: NewsContentType.Text,
      text:
        '图说：豇豆因喜温、喜旱，在鲜嫩的状态下极易招致虫害 采访对象提供（下同）',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
      '之后在标准指导下，基地结合专业人员的经验制定了更详细的植保方案，什么时候防虫，什么时候施肥、浇水都有记录可查，并留出了足够的防治安全间隔期，最大限度减少残留风险。同时做好包括基地快检、三方定期检测、大仓抽检等多环节在内的100%批次检测，确保不让不符合国家食品安全标准的豇豆流入市场。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '据了解，叮咚买菜的D-G.A.P标准是针对平台初级农产品的安全生产制定的操作规范，鼓励上游生产者减少农用化学药品的使用，重点关注农产品安全、环境保护以及工人的健康、安全等。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '“在接触叮咚买菜D-G.A.P之前，我们对防治时间、安全间隔期都没有系统的概念，种植的规范化程度也不够，田间的生产记录也并不完善。按照叮咚的要求进行改进之后，我们的各项生产流程更加规范，才顺利通过了认证，这加大了我们种出‘三优’豇豆的信心。”李相斌说。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '辞旧迎新的日子里，依然有许多干部职工坚守岗位、奋战一线，筑牢上海疫情防控坚实屏障、确保超大城市安全有序。今天上午（1月30日），市委书记李强，市委副书记、市长龚正结合“促发展、保安全”大走访、大排查，前往消防救援、燃气调度、地铁运营等部门单位以及相关企业、医疗机构、主副食品配送站点，检查春节期间城市保障和疫情防控工作，慰问基层一线劳动者、消防救援人员和医务工作者。李强指出，城市安全、市民安宁、节日安好，离不开全市广大干部职工的辛勤付出、持续坚守。要深入贯彻落实习近平总书记对上海工作的重要指示要求，始终保持思想上的警醒警惕、行动上的坚决有力，严而又严、细而又细、实而又实地把各项安全保障和疫情防控措施落到实处，让全市人民过一个欢乐、祥和、安全的春节。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '付出的精力和心血有了回报，基地目前亩产超6000斤豇豆，并在平台获得了极高评价。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '叮咚买菜透露，上线两个多月，“三优”豇豆的销量同比去年非订单模式下的销量增长2倍多，“三优”系列蔬菜整体销量同比增长4.5倍。',
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: NewsContentType.Text,
      text:
        ' 叮咚买菜的“三优”豇豆基地是生鲜零售渠道深度切入上游的典型案例。李相斌直言：“希望通过好的渠道，让高品质农产品‘有市有价’，稳定产出，不至于陷入低品质和低价格的竞争漩涡，在产业升级中寻找新的机会。”',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '辞旧迎新的日子里，依然有许多干部职工坚守岗位、奋战一线，筑牢上海疫情防控坚实屏障、确保超大城市安全有序。今天上午（1月30日），市委书记李强，市委副书记、市长龚正结合“促发展、保安全”大走访、大排查，前往消防救援、燃气调度、地铁运营等部门单位以及相关企业、医疗机构、主副食品配送站点，检查春节期间城市保障和疫情防控工作，慰问基层一线劳动者、消防救援人员和医务工作者。李强指出，城市安全、市民安宁、节日安好，离不开全市广大干部职工的辛勤付出、持续坚守。要深入贯彻落实习近平总书记对上海工作的重要指示要求，始终保持思想上的警醒警惕、行动上的坚决有力，严而又严、细而又细、实而又实地把各项安全保障和疫情防控措施落到实处，让全市人民过一个欢乐、祥和、安全的春节。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '订单种植模式的直接意义，就是为种植者避免随行就市带来的市场风险，从而获取更加稳定、长远的收益。而在订单之外，叮咚买菜为基地赋能的标准则更加重要，这是确保优质品质的基础，也是新型订单农业的特点之一。 ',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '有了订单和科学的植保方案，李相斌如今也有了充足的底气去洽谈更好的农资资源，让农户平时触及不到的优质农资真正普惠到田间地头上，也为产区的相关从业者带来生产高品质农产品的动力。当然更加现实的，还是为更多当地农户多提供一份相对稳定的工作。 ',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '叮咚买菜“三优”蔬菜项目负责人王兴银表示：“对于生鲜农产品，叮咚买菜没有停留在传统的采购上，而是推出了新型订单农业这种供应链组织管理模式，采用科学的种植理念赋能上游，促成更多农业资源的整合与落地，有针对性、有方法地为源头解决问题，同时带动优质产区的农户、农业工人增收。”        ',
    },
  ],
};
